import * as requestFromServer from "./pushNotificationApis";
import i18n from 'i18next'
import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";


// push notification -> send notification api
export const sendOrganizationPushNotificationAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.sendOrganizationPushNotification(dataToBeSent);
    if (response) {
      toastService.success(i18n.t("Modules.Notify.notificationSentSuccessfully"));
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// push notification -> get notification api
export const getOrganizationPushNotificationAction = (setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getOrganizationPushNotification();
    if (response) {
      dispatch(Actions.createAction(Actions.GET_PUSH_NOTIFICATION_LIST, {pushNotifications:response}))
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

// push notification -> get notification api
export const getSentOrganizationPushNotificationListAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getSentOrganizationPushNotificationList(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SENT_PUSH_NOTIFICATION_LIST, {sentPushNotifications:response}))
      setLoading(false);
      return response;
    }
    else {
      setLoading(false)
      return null
    }
};

